import React, { Component } from 'react';
import { connect } from 'react-redux';
import AvaRIEInput from '../fields/input/AvaRIEInput';

import LANGUAGES_CONTROLLER from '../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

const log = new Logger('BOOKING_INFO', LOG_LEVELS.DEBUG);

class BookingInfo extends Component {

  render() {
    //log.debug('render(): ', this.props);

    return (
      <ReadOnlyWrapper>
        <tr key={this.props.key} className={withFullStoryExclude()}>
          <td>
            <AvaRIEInput
              propName={this.props.fieldRefs.AccountNumber}
              value={this.props.formData[this.props.fieldRefs.AccountNumber]}
              change={this.props.change}
            />
          </td>
          <td>
            <AvaRIEInput
              propName={this.props.fieldRefs.Amount}
              value={this.props.formData[this.props.fieldRefs.Amount]}
              change={this.props.change}
            />
          </td>
          <td>
            <AvaRIEInput
              propName={this.props.fieldRefs.Currency}
              value={this.props.formData[this.props.fieldRefs.Currency]}
              change={this.props.change}
            />
          </td>
          <td>
            <AvaRIEInput
              propName={this.props.fieldRefs.VATCode}
              value={this.props.formData[this.props.fieldRefs.VATCode]}
              change={this.props.change}
            />
          </td>
        </tr>
      </ReadOnlyWrapper>
    );
  }
}
  

function mapStateToProps(state, props) {
  return {
    // Almost all components will need to use language strings, so add them to the props from the global state
    languages: state.languages,
  };
}


function mapDispatchersToProps(dispatch) {
  return {
    //TODO: Add dispatchers (actions we expect controllers to perform) here.
  }
}
// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(BookingInfo);
